import * as React from 'react';

import localStorage from 'core/local-storage/localStorage';
import Article from 'pages/content/components/Article/Article';

export class Preview extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: localStorage.get('DRAFT'),
    };
  }

  public render() {
    return <Article data={{ article: this.state.data || {} }} />;
  }
}
